import { z } from "zod";

export const suggestedAccrualMatchTransactionsForInvoiceQuerySchema = z.object({
    page: z.coerce.number().int().min(0).default(0),
    limit: z.coerce.number().int().positive().max(100).default(20),
    filters: z
        .object({
            entityIds: z.array(z.coerce.number()).optional(),
            search: z.string().optional(),
        })
        .optional(),
});

export type SuggestedAccrualMatchTransactionsForInvoiceQuery = z.infer<
    typeof suggestedAccrualMatchTransactionsForInvoiceQuerySchema
>;
